import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CenterRateCurrency, Currency } from '../models/currency';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {
  private readonly API_URL = `${environment.apiUrl}/currency`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<Currency[]> {
    return this.http.get<Currency[]>(this.API_URL);
  }

  getActiveCurrencies(): Observable<Currency[]> {
    return this.http.get<Currency[]>(`${this.API_URL}/active`);
  }

  getCenterRateCurrency(): Observable<CenterRateCurrency | null> {
    return this.http.get<CenterRateCurrency | null>(`${this.API_URL}/center-rate-currency`);
  }

  updateCenterRateCurrency(currencyId: number): Observable<CenterRateCurrency> {
    return this.http.put<CenterRateCurrency>(`${this.API_URL}/center-rate-currency`, { currencyId });
  }

  getById(id: number): Observable<Currency> {
    return this.http.get<Currency>(`${this.API_URL}/${id}`);
  }

  create(currency: Currency): Observable<Currency> {
    return this.http.post<Currency>(this.API_URL, currency);
  }

  update(id: number, currency: Currency): Observable<Currency> {
    return this.http.put<Currency>(`${this.API_URL}/${id}`, currency);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }
}
